import type { FunctionComponent } from "react";
import {
  Price,
  SkeletonLoader,
  SkeletonLoaderProps,
  Tag,
  type TagColor,
} from "@kanda-libs/ks-design-library";
import useLoanStatusProps from "components/loan/LoanTable/LoanStatus/useLoanStatusProps";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/loan/LoanTable/LoanStatus/constants";

export interface LoanStatusProps {
  total: number;
  status: string;
  id: string;
  provider: string;
  isLoading: boolean;
  skeletonClassName: string;
  skeletonProps?: SkeletonLoaderProps;
}

const LoanStatus: FunctionComponent<LoanStatusProps> = function ({
  total,
  status,
  id,
  provider,
  isLoading,
  skeletonClassName,
  skeletonProps = {},
}) {
  const { color, priceColor, classNames, searchWords } =
    useLoanStatusProps(status);

  return (
    <SkeletonLoader
      isLoading={isLoading}
      className={skeletonClassName}
      {...skeletonProps}
      afterLoading={
        <div className="flex flex-col max-w-full">
          <div className="flex flex-row mb-1">
            <Price amount={total} color={priceColor} {...classNames} />
            <Tag
              label={provider}
              color="grey"
              size={21}
              className="my-auto ml-2"
              variant="solid"
            />
            <Tag
              label={status.replace(/_/g, " ")}
              color={color as TagColor}
              size={21}
              className="my-auto ml-2 mr-auto"
              variant="solid"
            />
          </div>

          <Highlighter
            {...HIGHLIGHT_PROPS}
            searchWords={searchWords}
            textToHighlight={id || ""}
            className="text-12-18"
          />
        </div>
      }
    />
  );
};

export default LoanStatus;
